import { combineReducers, Action } from 'redux';
import processReducer, { initialState as processes } from './processReducer';
import activityReducer, { initialState as activities } from './activityReducer';
import assistantReducer, { initialState as assistants } from './assistantReducer';
import assistantRunReducer, { initialState as assistantRuns } from './assistantRunReducer';
import activityRunReducer, { initialState as activityRuns } from './activityRunReducer';
import activityRunConsoleMessageReducer, {
  initialState as activityRunConsoleMessages,
} from './activityRunConsoleMessageReducer';
import activityRunEventReducer, {
  initialState as activityRunEvents,
} from './activityRunEventReducer';
import artifactReducer, { initialState as artifacts } from './artifactReducer';
import containerImageReducer, { initialState as containerImages } from './containerImageReducer';
import processScheduleReducer, { initialState as processSchedules } from './processScheduleReducer';
import processStatusReducer, { initialState as processStatuses } from './processStatusReducer';
import secretReducer, { initialState as secrets } from './secretReducer';
import activityTemplateReducer, {
  initialState as activityTemplates,
} from './activityTemplateReducer';
import workspaceKeysReducer, { initialState as workspaceKeys } from './workspaceKeysReducer';
import slackReducer, { initialState as slack } from './slackReducer';

const workspacesReducer = combineReducers({
  activityTemplates: activityTemplateReducer,
  activities: activityReducer,
  activityRuns: activityRunReducer,
  artifacts: artifactReducer,
  activityRunConsoleMessages: activityRunConsoleMessageReducer,
  activityRunEvents: activityRunEventReducer,
  assistants: assistantReducer,
  assistantRuns: assistantRunReducer,
  containerImages: containerImageReducer,
  processes: processReducer,
  processSchedules: processScheduleReducer,
  processStatuses: processStatusReducer,
  secrets: secretReducer,
  workspaceKeys: workspaceKeysReducer,
  slack: slackReducer,
});

const initialState: ReturnType<typeof workspacesReducer> = {
  activityTemplates,
  assistants,
  assistantRuns,
  processes,
  activities,
  activityRuns,
  artifacts,
  activityRunConsoleMessages,
  activityRunEvents,
  containerImages,
  processSchedules,
  processStatuses,
  secrets,
  workspaceKeys,
  slack,
};

const rootReducer = (state = initialState, action: Action) => {
  if (action.type === 'SET_CURRENT_WORKSPACE_ID') {
    state = initialState;
  }

  return workspacesReducer(state, action);
};

export default rootReducer;
